import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { dataLayer } from '@doda/common/src/utils/googleTagManagerUtil';
import {
  measureSimilarKeywordApplyJob,
  measureSimilarKeywordFavorite,
} from 'pages/DodaFront/View/JobSearchList/logics/analytics';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from 'redux/store';

/**
 * 求人の気になる押下時の計測処理
 * @param jid 求人ID
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns 求人の気になる押下時の計測
 */
export const measureBookmarkJobCard =
  (jid: string, existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    // 類似キーワード計測
    dispatch(measureSimilarKeywordFavorite(existSimilarKeyword));

    // GA計測
    dataLayer({
      JobId: jid,
      event: 'bookmark_click',
    });

    // AA計測
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    tlReadyExecute(isAdobeScript, dispatch, 'kininaruClick_JobSearchList', {
      products: `;${jid}`,
      events: 'event120',
      prop23: 'kininaru_Click',
      prop32: jid,
      eVar23: 'kininaru_Click',
    });
  };

type JobOfferType = 'Direct' | 'Agent';
const map: Record<JobOfferType, Record<'linkName' | 'events', string>> = {
  Direct: {
    linkName: 'Chokusetsu Ichiran',
    events: 'event8',
  },
  Agent: {
    linkName: 'Shokai Ichiran',
    events: 'event5',
  },
};

/**
 * 求人カードの応募ボタン押下時の計測
 * @param jid 求人ID
 * @param type 応募ボタン種別
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns 求人カードの応募ボタン押下時の計測
 */
export const measureApplyJob =
  (
    jid: string,
    type: JobOfferType,
    existSimilarKeyword: boolean
  ): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    // 類似キーワード計測
    dispatch(measureSimilarKeywordApplyJob(existSimilarKeyword));

    // GA計測
    dataLayer({
      event: 'setEffect',
      click_Label: map[type].events,
      click_Action: '求人一覧ボタン',
      click_Category: map[type].linkName,
    });

    // AA計測
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    tlReadyExecute(isAdobeScript, dispatch, map[type].linkName, {
      products: `;${jid}`,
      prop23: '求人一覧ボタン',
      eVar23: '求人一覧ボタン',
    });
  };
